import ColorfulAvatar from './colorful-avatar';
export default ColorfulAvatar;
